export const initialState = [
  {
    id: 1,
    title: "delectus aut autem",
    category: "Article",
    img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    admin: "Sumit",
  },

  {
    id: 2,
    title: "qui ullam ratione quibusdam voluptatem quia omnis",
    img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "Write",
    admin: "Remon",
  },
  {
    id: 3,
    title: "et porro tempora",
    category: "Word",
    img: "https://images.unsplash.com/photo-1496128858413-b36217c2ce36?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    admin: "Jhankar",
  },
  {
    id: 4,
    title: "quis ut nam facilis et officia qui",
    category: "Article",
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",

    admin: "Sumit",
  },
  {
    id: 5,
    title: "laboriosam mollitia et enim quasi adipisci quia provident illum",
    img: "https://images.unsplash.com/photo-1547586696-ea22b4d4235d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    category: "Write",
    admin: "Remon",
  },
  {
    id: 6,
    title: "fugiat veniam minus",
    category: "Word",
    img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1679&q=80",
    admin: "Jhankar",
  },
];
